// 协议类型-用户协议
export const PROTOCOL_USER_TYPE = '1';
// 协议类型-隐私政策
export const PROTOCOL_PRIVACY_TYPE = '2';
// 协议类型-共享计划协议
export const PROTOCOL_SHARE_PLAN_TYPE = '3';
// 协议类型-隐私政策简要版
export const PROTOCOL_PRIVACY_BRIEF_TYPE = '4';
// 协议类型-个人信息收集清单
export const PROTOCOL_PERSONAL_INFORMATION_COLLECTION_TYPE = '5';
// 协议类型-应用权限申请与使用情况说明
export const PROTOCOL_APPLICATION_PERMISSION_DESCRIPTION_TYPE = '6';
// 协议类型-个人信息共享清单
export const PROTOCOL_PERSONAL_INFORMATION_SHARING_TYPE = '7';

export const PROTOCOL_TYPE_TEXT_MAP = {
  [PROTOCOL_USER_TYPE]: '用户协议',
  [PROTOCOL_PRIVACY_TYPE]: '隐私政策',
  [PROTOCOL_SHARE_PLAN_TYPE]: '共享计划协议',
  [PROTOCOL_PRIVACY_BRIEF_TYPE]: '隐私政策(简要版)',
  [PROTOCOL_PERSONAL_INFORMATION_COLLECTION_TYPE]: '个人信息收集清单',
  [PROTOCOL_APPLICATION_PERMISSION_DESCRIPTION_TYPE]: '应用权限申请与使用情况说明',
  [PROTOCOL_PERSONAL_INFORMATION_SHARING_TYPE]: '个人信息共享清单',
};

export const WEB_ORIGIN = '5';
export const WEB_FLAVOR = 'onethingcloud';
